import { TypePolicy } from '@apollo/client'

const Market: TypePolicy = {
  keyFields: ['marketId'],
}

export default Market
